import { create } from "zustand";
import {
  FilterCriteria,
  GroupByCriteria,
  IncidentQueryField,
  OrderByCriteria,
} from "../types/salesforce";

interface QueryState {
  query: string;
  facilityId: string[];
  selectedFields: IncidentQueryField[];
  availableFields: IncidentQueryField[];
  filters: FilterCriteria[];
  logicExpression: string | null;
  orderBy: OrderByCriteria | null;
  groupBy: GroupByCriteria[];
  setQuery: (query: string) => void;
  setFacilityId: (id: string[]) => void;
  setSelectedFields: (fields: IncidentQueryField[]) => void;
  setAvailableFields: (fields: IncidentQueryField[]) => void;
  setFilters: (filters: FilterCriteria[]) => void;
  setLogicExpression: (expression: string | null) => void;
  setOrderBy: (orderBy: OrderByCriteria | null) => void;
  setGroupBy: (groupBy: GroupByCriteria[]) => void;
  resetState: () => void;
}

export const useQueryBuilder = create<QueryState>((set) => ({
  query: "",
  facilityId: [],
  selectedFields: [],
  availableFields: [],
  filters: [],
  logicExpression: null,
  orderBy: null,
  groupBy: [],
  setQuery: (query) => set({ query }),
  setFacilityId: (id) => set({ facilityId: id }),
  setSelectedFields: (fields) => set({ selectedFields: fields }),
  setAvailableFields: (fields) => set({ availableFields: fields }),
  setFilters: (filters) => set({ filters }),
  setLogicExpression: (expression) => set({ logicExpression: expression }),
  setOrderBy: (orderBy) => set({ orderBy }),
  setGroupBy: (groupBy) => {
    set({ groupBy });
  },
  resetState: () =>
    set({
      query: "",
      facilityId: [],
      selectedFields: [],
      availableFields: [],
      filters: [],
      logicExpression: null,
      orderBy: null,
      groupBy: [],
    }),
}));
